import { create } from "zustand";

/**
 * Session-local "the user explicitly expanded the onboarding panel on a
 * programme route" flag, shared between POnboarding (the floating checklist
 * panel) and OnboardingPill (the appbar expand affordance).
 *
 * The programme timeline owns the bottom-right canvas corner the panel docks
 * to, so the panel DEFAULT-minimizes there (same route gate the coach uses —
 * isProgrammeRoute). An explicit expand via the pill wins for the rest of the
 * session; an explicit minimize (the panel's chevron) clears it again.
 * Deliberately NOT persisted: unlike the provider's isMinimized (a lasting
 * user choice), this is a per-session route default override.
 */
interface ProgrammePanelState {
  /** True once the user explicitly expanded the panel on a programme route. */
  userExpanded: boolean;
  setUserExpanded: (v: boolean) => void;
}

export const useProgrammePanelStore = create<ProgrammePanelState>((set) => ({
  userExpanded: false,
  setUserExpanded: (v) => set({ userExpanded: v }),
}));
